<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb" />
    <div class="wrap max-width">
      <div class="title">{{ data ? data.title : '' }}</div>
      <!-- <div class="desc">
        <span>日期：{{ data.updTm ? data.updTm.slice(0, 10) : '' }}</span>
      </div> -->
      <!-- {{ data.cont }} -->
      <div class="cont" v-html="data.cont" />
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === '首页') {
        // 处理语句，可以是 data 中的数据，也可以是 methods中的函数。vm 相当于 this
        vm.breadcrumb = [
          {
            path: '/',
            name: '首页',
            meta: {
              title: '首页',
            },
          },
          {
            path: '/service-marketdetail',
            name: '服务简介',
            meta: {
              title: '服务简介',
            },
          },
        ]
      } else {
        vm.breadcrumb = [
          {
            path: '/',
            name: '首页',
            meta: {
              title: '首页',
            },
          },
          {
            path: '/service-market',
            name: '服务超市',
            meta: {
              title: '服务超市',
            },
          },
          {
            path: '/service-marketdetail',
            name: '服务简介',
            meta: {
              title: '服务简介',
            },
          },
        ]
      }
    })
  },

  data() {
    return {
      data: {},
      breadcrumb: [],
    }
  },
  mounted() {
    this.getDetails()
  },
  methods: {
    getDetails() {
      this.$http({ method: 'get', url: '/zzmh/api/service/info/' + this.$route.query.id }).then(({ data: res }) => {
        console.log(res)
        this.data = res
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
